import { createSelector } from 'reselect'

import {
  selectActualDefaultLanguage,
  selectActualEnabledLanguagesOptions,
} from 'containers/App/selectors'

const selectError = (state) => state.scenarioForm.error

const selectSaveLoader = (state) => state.scenarioForm.saveLoader
const selectGetDetailsLoader = (state) => state.scenarioForm.getDetailsLoader
const selectGetScenarioLoader = (state) => state.scenarioForm.getScenarioLoader
const selectCreatedCampaignId = (state) => state.scenarioForm.createdCampaignId
const selectCreateCampaignLoader = (state) => state.scenarioForm.createCampaignLoader
const selectMainLoader = createSelector(
  selectGetDetailsLoader,
  selectGetScenarioLoader,
  selectSaveLoader,
  selectCreateCampaignLoader,
  (getDetailsLoader, getScenarioLoader, saveLoader, createCampaignLoader) =>
    getDetailsLoader || getScenarioLoader || saveLoader || createCampaignLoader
)

const selectSortedLanguageOptions = createSelector(
  selectActualEnabledLanguagesOptions,
  selectActualDefaultLanguage,
  (languagesOptions, defaultLanguage) => {
    const sortedLanguageOptions = [...languagesOptions]
      .sort((a) => {
        if (a.value === defaultLanguage.id) return -1
        else return 0
      })
      .map((item) => {
        const lang = { ...item }

        if (lang.value === defaultLanguage.id) {
          lang.label = `${lang.label} (Default)`
        }

        return lang
      })

    return sortedLanguageOptions
  }
)

const selectScenario = (state) => state.scenarioForm.scenario
const selectDetails = (state) => state.scenarioForm.details
const selectScenarioLangValues = (state) => state.scenarioForm.scenarioLangValues
const selectScenarioWasLoaded = (state) => state.scenarioForm.scenarioWasLoaded
const selectIsDefaultTabValid = (state) => state.scenarioForm.isDefaultTabValid

export {
  selectError,
  selectSaveLoader,
  selectGetDetailsLoader,
  selectGetScenarioLoader,
  selectMainLoader,
  selectScenario,
  selectDetails,
  selectCreatedCampaignId,
  selectScenarioLangValues,
  selectSortedLanguageOptions,
  selectScenarioWasLoaded,
  selectIsDefaultTabValid,
}

export const selectCopyFromId = (state) => selectScenario(state).copy_from_id
